// Copyright (C) 2012-present, The Authors. This program is free software: you can redistribute it and/or  modify it under the terms of the GNU Affero General Public License, version 3, as published by the Free Software Foundation. This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU Affero General Public License for more details. You should have received a copy of the GNU Affero General Public License along with this program.  If not, see <http://www.gnu.org/licenses/>.

import PropTypes from 'prop-types'
import { Navigate } from 'react-router'
import { Box, Button, Text } from 'theme-ui'

import { useAuth } from 'react-oidc-context'
import Logomark from '../framework/Logomark'

const SignIn = ({ authed }) => {
  const auth = useAuth()

  if (authed) {
    return <Navigate to={'/'} />
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3
      }}>
      <Box
        sx={{
          textAlign: 'center',
          maxWidth: '360px',
          width: '100%'
        }}>
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
          <Logomark withText fill="#03A9F4" size={60} />
        </Box>
        <Text
          as="h1"
          sx={{
            color: '#0F1722',
            fontSize: [4, 5],
            fontWeight: 'bold',
            mb: 2,
            display: 'block'
          }}>
          Polis
        </Text>
        <Text
          sx={{
            color: '#5A6883',
            fontSize: 2,
            mb: 5,
            display: 'block'
          }}>
          Платформа демократичного залучення
        </Text>
        <Button
          sx={{
            width: '100%',
            py: 3,
            fontSize: 2,
            fontWeight: 'bold',
            backgroundColor: 'primary',
            borderRadius: 'default',
            cursor: 'pointer',
            '&:hover': { backgroundColor: 'infoHover' }
          }}
          id="signinButton"
          onClick={() =>
            auth.signinRedirect({
              state: { returnTo: window.location.pathname }
            })
          }>
          Увійти
        </Button>
        <Box sx={{ mt: 3 }}>
          <Text sx={{ color: '#8A94A8', fontSize: 1 }}>
            polis.cid.center — Центр розвитку інновацій
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

SignIn.propTypes = {
  authed: PropTypes.bool
}

export default SignIn
